import {MutationTree} from 'vuex';
import {Loading, LoadingInitState} from '@/store/loading/loading.types';

export const LoadingMutations: MutationTree<LoadingInitState> = {
  ['Loading'](state: LoadingInitState, payload: boolean) {
    state.Load.loading = payload;
  }
};
